import {
  Dialog,
  DialogTitle,
  IconButton,
  Paper,
  SwipeableDrawer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';
import { useDialogContext } from './dialog-context';

export default function ResponsiveDialog() {
  const { isOpen, title, content, closeDialog, openDialog } =
    useDialogContext();

  // Draggable Paper wrapper for desktop Dialog
  const PaperComponent = props => (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="sm"
        open={isOpen}
        onClose={closeDialog}
        PaperComponent={PaperComponent}
        aria-labelledby="responsive-dialog-title"
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDialog-paper': {
            background: 'linear-gradient(135deg, #F8FAFC 0%, #E6F6F4 100%)',
            borderRadius: '20px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            backdropFilter: 'blur(8px)',
            transition: 'box-shadow 0.3s ease',
            '&:hover': {
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
            },
            m: 2,
            direction: 'rtl',
          },
        }}
      >
        <DialogTitle
          id="draggable-dialog-title" // Drag handle ID
          sx={{
            p: 4,
            m: 0,
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#1e293b',
            letterSpacing: '0.5px',
            position: 'relative',
            background: 'transparent',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            pr: 6,
            cursor: 'grab', // Hand drag cursor (open hand/grab icon)
            userSelect: 'none', // Prevent text selection while dragging
            '&:active': {
              cursor: 'grabbing', // Closed hand during drag
            },
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
              color: '#f43f5e',
              transition: 'color 0.3s ease, transform 0.2s ease',
              '&:hover': {
                color: '#e11d48',
                transform: 'scale(1.1)',
                backgroundColor: 'rgba(244, 63, 94, 0.05)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {content}
      </Dialog>
      <SwipeableDrawer
        open={isOpen}
        onClose={closeDialog}
        onOpen={openDialog}
        anchor="bottom"
        disableSwipeToOpen
        ModalProps={{ onBackdropClick: closeDialog }}
        sx={{
          display: { md: 'none' },
          '& .MuiPaper-root': {
            height: 'auto',
            maxHeight: '80vh',
            borderTopRightRadius: '20px',
            borderTopLeftRadius: '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            backdropFilter: 'blur(8px)',
            transition: 'box-shadow 0.3s ease',
            '&:hover': {
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
            },
            p: 4,
            px: 2,
            direction: 'rtl',
          },
        }}
      >
        <DialogTitle
          id="responsive-dialog-title"
          sx={{
            p: 0,
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#1e293b',
            letterSpacing: '0.5px',
            position: 'relative',
            mb: 3,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            pr: 6,
          }}
        >
          {title}
          <IconButton
            aria-label="close"
            onClick={closeDialog}
            sx={{
              position: 'absolute',
              right: 0,
              top: 8,
              color: '#f43f5e',
              transition: 'color 0.3s ease, transform 0.2s ease',
              '&:hover': {
                color: '#e11d48',
                transform: 'scale(1.1)',
                backgroundColor: 'rgba(244, 63, 94, 0.05)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {content}
      </SwipeableDrawer>
    </>
  );
}
